module.exports = __webpack_public_path__ + "72e8e45d89fc05fefd0c145cfed735d9.jpg";